<template>
  <carousel
          v-animate.fade="'slide-up'"
          ref="carousel"
          :value="value"
          :per-page="1"
          :per-page-custom="[[1025, 3]]"
          :pagination-enabled="false"
          @input="v => $emit('input', v)">
    <slide>
      <example :people="1" v-bind:lines_data="lines_data[0]" label="For one person"/>
    </slide>
    <slide>
      <example :people="2" v-bind:lines_data="lines_data[1]" label="For family"/>
    </slide>
    <slide>
      <example  v-if="this.$route.params.id === 'antigua-and-barbuda-citizenship-investment-programme'" :people="4" v-bind:lines_data="lines_data[2]" label="For family + 2 child (12-17 years)"/>
      <example v-else :people="4" v-bind:lines_data="lines_data[2]" label="For family + 2 child (0-16 years)"/>
    </slide>
    <slide>
      <example v-if="this.$route.params.id === 'antigua-and-barbuda-citizenship-investment-programme'" :people="5" v-bind:lines_data="lines_data[3]" label="For family + 3 child (12-17 years)"/>
      <example v-else :people="5" v-bind:lines_data="lines_data[3]" label="For family + 3 child (0-16 years)"/>
    </slide>
  </carousel>
</template>

<script>
    import Example from './example';
    import { mapGetters } from 'vuex';

    export default {
        components: { Example },
        props: {
            value: { type: Number, default: 0 },
            lines_data:  { type: Array }
        },
        methods: {
            prev() {
                this.$refs.carousel.advancePage('backward');
            },
            next() {
                this.$refs.carousel.advancePage('forward');
            },
        },
    };
</script>